import { Link } from "@/components/site/LocaleLink";
import { IMG } from "@/data/images";
import { useLang } from "@/context/LanguageContext";

export const Logo = ({ variant = "header", className = "", to = "/" }) => {
  const { lang } = useLang();
  const src = variant === "footer" ? IMG.logoCream : IMG.logoForest;
  const textColor = variant === "footer" ? "text-cream" : "text-forest";
  const nameEn = "AL-ABRAD";
  const nameAr = "الأبرد";
  const subEn = "Veterinary Trading Co.";
  const subAr = "لتجارة الأدوية البيطرية";

  return (
    <Link to={to} className={`inline-flex items-center gap-3 group ${className}`} data-testid="logo-link">
      <img
        src={src}
        alt="Al-Abrad logo"
        width={364}
        height={362}
        decoding="async"
        className="h-11 w-auto transition-transform duration-500 ease-out group-hover:-translate-y-0.5"
      />
      <span className="flex flex-col leading-none">
        <span className={`font-display font-extrabold text-lg tracking-tight ${textColor}`}>
          {lang === "ar" ? nameAr : nameEn}
        </span>
        <span className={`text-[10px] tracking-[0.14em] mt-1 ${variant === "footer" ? "text-cream/60" : "text-stone"}`}>
          {lang === "ar" ? subAr : subEn}
        </span>
      </span>
    </Link>
  );
};
